import { lowerFirst } from './string-utils'

type CamelCaseObjProps = {
  [key: string]: any // eslint-disable-line
}

export const convertKeysToCamelcase = (obj: CamelCaseObjProps): object => {
  if (Array.isArray(obj)) {
    return obj.map(v => convertKeysToCamelcase(v))
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [lowerFirst(key)]: convertKeysToCamelcase(obj[key]),
      }),
      {}
    )
  }
  return obj
}

/**
 * Deep clones an object, including any functions
 * @param obj the object to be cloned
 * @returns a copy of the provided object
 */
export const cloneObject = <T>(obj: T): T => {
  // Check if the input is an object or a function
  if (obj === null || (typeof obj !== 'object' && typeof obj !== 'function')) {
    return obj
  }

  // Handle Date
  if (obj instanceof Date) {
    return new Date(obj.getTime()) as unknown as T
  }

  // Handle Array
  if (Array.isArray(obj)) {
    return obj.map(item => cloneObject(item)) as unknown as T
  }

  // Handle Object
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const clonedObj: { [key: string]: any } = {}
  for (const key in obj) {
    // Ensure the property is not on the prototype chain
    if (Object.hasOwn(obj, key)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      clonedObj[key] = cloneObject((obj as { [key: string]: any })[key])
    }
  }

  // Handle function
  if (typeof obj === 'function') {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return (obj as unknown as Function).bind({}) as unknown as T
  }

  return clonedObj as T
}
